import React, { useState, useEffect } from 'react';
import { fetchStageList } from '../../../services/ResultsApi';

const ImportGeofenceModal = ({ onClose, onImport }) => {
    const [stages, setStages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedStageId, setSelectedStageId] = useState('');
    const [competitionId, setCompetitionId] = useState(localStorage.getItem('admin_competition_id') || '');

    useEffect(() => {
        if (competitionId) {
            loadStages();
        }
    }, [competitionId]);

    const loadStages = async () => {
        setLoading(true);
        try {
            const list = await fetchStageList(competitionId);
            setStages(Array.isArray(list) ? list : []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleImport = () => {
        if (!selectedStageId) return;
        // ResultsApi returns ID as ID (upper case) or id? Let's check. 
        // Based on previous files, likely ID. But let's handle loose matching.
        const stage = stages.find(s => String(s.ID) === String(selectedStageId));
        if (stage) {
            // Normalize for parent
            onImport({
                id: stage.ID,
                name: stage.Name
            });
        }
    };

    const handleCompetitionIdChange = (e) => {
        const val = e.target.value;
        setCompetitionId(val);
        localStorage.setItem('admin_competition_id', val);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h3 className="modal-title">Import Geofences from Stage</h3>
                    <button className="modal-close-btn" onClick={onClose}>
                        <span className="material-icons-outlined">close</span>
                    </button>
                </div>
                <div className="modal-body">
                    <p className="form-label">Select a stage to generate geofences (Start, Meta) based on its details.</p>

                    <div className="form-group">
                        <label className="form-label">Competition ID</label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <input
                                type="text"
                                className="form-input"
                                value={competitionId}
                                onChange={handleCompetitionIdChange}
                                placeholder="Enter Comp ID"
                                style={{ flex: 1 }}
                            />
                            <button className="btn btn-secondary" onClick={loadStages} disabled={loading}>
                                Load
                            </button>
                        </div>
                    </div>

                    {loading ? (
                        <div>Loading stages...</div>
                    ) : (
                        <div className="form-group">
                            <label className="form-label">Stage</label>
                            <select
                                className="form-select"
                                value={selectedStageId}
                                onChange={(e) => setSelectedStageId(e.target.value)}
                                disabled={!stages.length}
                            >
                                <option value="">-- Select Stage --</option>
                                {stages.map(stage => (
                                    <option key={stage.ID} value={stage.ID}>
                                        {stage.Name} (ID: {stage.ID})
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                    <button
                        className="btn btn-primary"
                        onClick={handleImport}
                        disabled={!selectedStageId || loading}
                    >
                        Import
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImportGeofenceModal;
